import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=56c64870"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c64870')) {
      api.createRecord('56c64870', component.options)
    } else {
      api.reload('56c64870', component.options)
    }
    module.hot.accept("./Packages.vue?vue&type=template&id=56c64870", function () {
      api.rerender('56c64870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/Packages.vue"
export default component.exports